import React from 'react';
import CardButton from '../CardButton/CardButton';
import './LeaderboardSlide.css';
import { cosmosTrackService } from '../../../../../cosmosTracking/cosmosTrackService';
import {view_leaderboard} from '../../../../../cosmosTracking/cosmosEvents';
import LeaderBoardTopInt from "../../LeaderboardInt/LeaderBoardTopInt";
import homeSlideAnimation from "../../../Resources/Slides/indipendence/top-performer.json";
import Lottie from "react-lottie";

function LeaderboardSlide(props) {
    const { data, deepLink, rewardText } = props;
    const boardSlideAnimationLottie = {
        loop: true,
        autoplay: true,
        animationData: homeSlideAnimation,
        rendererSettings: {
            preserveAspectRatio: 'xMidYMid slice',
        },
    };
    return (
        <div className="slideCard slideCardBoard">
            <div className="cardHeader">
                <Lottie options={boardSlideAnimationLottie} height={128}></Lottie>
            </div>
            <div className="cardContent">
                <LeaderBoardTopInt data={data}/>
                <CardButton
                    text={'View Leaderboard'}
                    deeplink={deepLink}
                    className={'btn-action'}
                    eventCallback={() => {
                        cosmosTrackService(view_leaderboard);
                }}/>
            </div>
        </div>
    );
}

export default LeaderboardSlide;
